import React from 'react';
import { withAutoMetric } from '@beef/auto-metric';
import { compose } from '@beef/redux';
import { enhancedConnect } from "../../utils";
import { Image } from "../Image";
import { BannerContainer } from "./components/BannerContainer";
import { BannerContent } from "./components/BannerContent";
export var _Banner = function _Banner(_ref) {
  var children = _ref.children,
    imgSrc = _ref.imgSrc,
    bgPosition = _ref.bgPosition,
    _ref$maxWidth = _ref.maxWidth,
    maxWidth = _ref$maxWidth === void 0 ? '1200px' : _ref$maxWidth,
    bgColor = _ref.bgColor,
    href = _ref.href,
    isBlankUrlTarget = _ref.isBlankUrlTarget,
    _ref$bgSize = _ref.bgSize,
    bgSize = _ref$bgSize === void 0 ? 'cover' : _ref$bgSize;
  return /*#__PURE__*/React.createElement(BannerContainer, {
    href: href,
    isBlankUrlTarget: isBlankUrlTarget,
    maxWidth: maxWidth,
    "data-t-id": "components-Banner"
  }, /*#__PURE__*/React.createElement(Image, {
    bgColor: bgColor,
    isBackground: true,
    position: bgPosition || 'right bottom',
    size: bgSize,
    src: imgSrc,
    "data-t-id": "components-Banner"
  }, /*#__PURE__*/React.createElement(BannerContent, {
    "data-t-id": "components-Banner"
  }, children)));
};
export var Banner = compose(enhancedConnect(), withAutoMetric.Container(function () {
  return {
    name: 'Banner'
  };
}))(_Banner);